module.exports = __webpack_public_path__ + "static/media/3.e3c17bed.jpg";